export const TAB_OPTIONS = {
  Invoice: 'invoice',
  ErpSync: 'erp-sync',
  QbSync: 'qb-sync',
  MorningSync: 'morning-sync',
  XeroSync: 'xero-sync',
  PaddleSync: 'paddle-sync',
};
